import { Destino } from "./destino";

export class Envios {

  color: string;
  destino: string;
  detalleServicio: string;
  estado: string;
  origen: string;
  conductor: string;
  fecha: string;
  hora: string;
  idCentroCosto: string;
  idCliente: string;
  idConductor: string;
  idEmpresa: string;
  idEstado: number;
  idModoReserva: string;
  idMovil: string;
  idServicio: number
  idTipoPago: string;
  idTipoServicio: string;
  latitudConductor: number;
  tiempoEstimadoEntrega : number;
  latitudDestino: number;
  latitudOrigen: number;
  longitudConductor: number;
  longitudDestino: number;
  longitudOrigen: number;
  modoReserva: string;
  movil: string;
  pasajero: string;
  placa: string;
  telefono: string;
  tipoPago: string;
  tipoServicio: string;
  total_servicio: string;
formaCalculo: number;



  

  objOrigen: any;
  objDestino: any;

  objOrigen2: any;
  objDestino2: any;



  objConductor: any;
  destinos: Destino[];
  destinosTracking : Destino[];
  origenTracking : Destino;
  estrellas: number;
  foto: string;

  estadoAcordion: boolean
  Calificado:boolean;
  idCalificacion:number;
  telefonoPasajero:string
  constructor() {
    /*this.pasajero = 'Jhon Pool',
    this.conductor =  'Elias',
    this.estrellas = 4.85,
    this.movil = 'Toyota Yaris',
    this.placa = 'D5T592'*/
  }
}
